<template>
  <draggable
    :list="slotItems"
    :group="group"
    :sort="false"
    item-key="id"
    class="value-link-drop"
    @change="onChange"
  >
    <template #item="{ element }">
      <span class="value-link-hidden">{{ element.pageUniqueTitle }}</span>
    </template>
    <template #footer>
      <div class="value-link-slot" role="group" aria-label="Value link" :class="{ linked: !!item.pageUniqueTitle }">
        <template v-if="item.pageUniqueTitle">
          <font-awesome-icon icon="link" />
          <span class="value-link-page">{{ item.pageUniqueTitle }}</span>
          <button type="button" class="value-link-clear" title="Remove link" @click.stop="clearLink">x</button>
        </template>
        <template v-else>
          Drop a page here to open it from this value
        </template>
      </div>
    </template>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import pageTitleFromDroppedItem from './menu-value-link.js'

export default {
  name: 'MenuValueLinkDrop',
  components: { draggable },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {

    return {
      slotItems: [],
      group: {
        name: 'menu',
        pull: false,
        put: (to, from, dragEl) => this.canAccept(dragEl)
      }
    }
  },
  methods: {
    canAccept (dragEl) {

      if (!dragEl || !dragEl.classList) return false

      return dragEl.classList.contains('available-page-item') ||
        dragEl.classList.contains('menu-item-link') ||
        dragEl.classList.contains('menu-child-link')
    },
    onChange (event) {

      const pageUniqueTitle = pageTitleFromDroppedItem(event && event.added && event.added.element)

      this.slotItems.splice(0, this.slotItems.length)

      if (pageUniqueTitle) this.item.pageUniqueTitle = pageUniqueTitle
    },
    clearLink () {

      delete this.item.pageUniqueTitle
    }
  }
}
</script>

<style scoped>
.value-link-drop {
  min-height: 32px;
}

.value-link-slot {
  margin: 0 12px 8px 36px;
  padding: 6px 8px;
  border: 1px dashed #3a3a37;
  border-radius: 3px;
  color: #a8a8a4;
  font-size: 0.75rem;
}

.value-link-slot.linked {
  display: flex;
  align-items: center;
  gap: 6px;
  border-style: solid;
  border-color: #2e2e2b;
  color: #b0b0ae;
}

.value-link-page {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.value-link-clear {
  border: 0;
  background: transparent;
  color: #8a8a86;
  cursor: pointer;
  line-height: 1;
}

.value-link-clear:hover {
  color: #e8e8e6;
}

.value-link-hidden {
  display: none;
}
</style>
